import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { FileLogger } from "@comunicare/comunicare-helper";
import { firstValueFrom } from "rxjs";

@Injectable({ providedIn: "root" })
export class ConfigService {
  private config: { apiUrl: string } | null = null;

  constructor(private http: HttpClient) {}

  async load(): Promise<void> {
    this.config = await firstValueFrom(this.http.get<{ apiUrl: string }>("/assets/config.json")).then(
      (config) => {
        FileLogger.log("ConfigService - load url", config.apiUrl);
        return config;
      },
      (err) => {
        FileLogger.error("ConfigService - load failed", err);
        return null;
      }
    );
  }

  get apiUrl(): string {
    return this.config?.apiUrl ?? "http://localhost:8080";
  }
}
